import { Injector, WritableSignal, runInInjectionContext, signal } from '@angular/core';
import {
    IgMetadataAgeEnum,
    IgMetadataColorEnum,
    IgMetadataEmotionEnum,
    IgMetadataGenderEnum,
    IgMetadataLabelEnum,
} from '@core/models/ApiFields/ig-entities.enums';
import { MetadataData } from '@features/social-analysis/social-listening/models/I-metadata';
import { PostMetadataHttpBuilder } from '../../social-listening/services/post-metadata.http';

export class MetadataState {
    data = signal<MetadataData>({
        [IgMetadataColorEnum.prefix]: [],
        [IgMetadataGenderEnum.prefix]: [],
        [IgMetadataAgeEnum.prefix]: [],
        [IgMetadataEmotionEnum.prefix]: [],
        [IgMetadataLabelEnum.prefix]: [],
    });
    isLoading: Record<string, WritableSignal<boolean>> = {
        [IgMetadataColorEnum.prefix]: signal(false),
        [IgMetadataGenderEnum.prefix]: signal(false),
        [IgMetadataAgeEnum.prefix]: signal(false),
        [IgMetadataEmotionEnum.prefix]: signal(false),
        [IgMetadataLabelEnum.prefix]: signal(false),
    };

    #http!: PostMetadataHttpBuilder;

    constructor(injector: Injector) {
        runInInjectionContext(injector, () => (this.#http = new PostMetadataHttpBuilder()));
    }

    reqMetadata(postId: string) {
        this.#http.reqData(this, postId);
    }
}
